import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const EventLogGlyph = /*#__PURE__*/createElement("g", {
  id: "event_log"
}, /*#__PURE__*/createElement("path", {
  d: "M68.89 31.23c-2.88-6.47-8.1-11.42-14.71-13.96-6.61-2.54-13.81-2.35-20.27.53-6.19 2.76-10.98 7.68-13.6 13.89l-4.64-10.42c-.34-.76-1.22-1.1-1.98-.76-.76.34-1.1 1.22-.76 1.98l5.9 13.25c.44.98 1.58 1.42 2.56.98l13.29-5.92c.76-.34 1.1-1.22.76-1.98-.34-.76-1.22-1.1-1.98-.76l-10.3 4.58c2.35-5.41 6.55-9.7 11.97-12.11a23.357 23.357 0 0117.98-.47c5.86 2.25 10.49 6.65 13.05 12.38 2.55 5.73 2.72 12.12.47 17.98-4.64 12.1-18.27 18.16-30.36 13.52-.77-.29-1.64.09-1.94.86s.09 1.64.86 1.94a26.23 26.23 0 009.47 1.76c10.66 0 20.73-6.48 24.77-17 2.53-6.61 2.34-13.81-.54-20.27z"
}), /*#__PURE__*/createElement("path", {
  d: "M53.43 50.79l-7.12-5.7V28.64c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v17.17c0 .03.01.05.01.08 0 .05.01.1.02.15l.03.14c.01.05.03.09.04.14.02.05.04.09.06.13.02.04.04.09.07.13.03.04.05.08.08.12.03.04.06.08.09.11l.11.11.06.06 7.68 6.15c.28.22.61.33.94.33.44 0 .88-.19 1.17-.56.51-.65.41-1.6-.24-2.11z"
}));
const EventLog = createSvg({
  name: 'event_log',
  path: EventLogGlyph
});

export default EventLog;
export { EventLogGlyph };
